import React from 'react'

interface ToggleButtonProps {
  index: number
  handleOtherInputButton: () => void
  checked?: boolean
}

const ToggleButton2: React.FC<ToggleButtonProps> = ({index, handleOtherInputButton, checked}) => {
  const handleToggle = () => {
    handleOtherInputButton()
  }

  return (
    <div className='flex items-center mt-2'>
      <div className='form-check form-switch form-check-custom form-check-solid'>
        <input
          className='form-check-input h-20px w-30px'
          type='checkbox'
          id={`switchCheck2${index}`}
          onClick={handleToggle}
          checked={checked}
        />
        <label className='form-check-label' htmlFor={`switchCheck2${index}`}>
          add "Other"
        </label>
      </div>
    </div>
  )
}

export default ToggleButton2
